export default __webpack_public_path__ + "static/media/salads.5000b33e.jpg";